import React from 'react';
import moment from 'moment';
import 'moment/locale/da';

moment.locale('da');

const TourList = ({ events }) => {
  return (
    <ul className="tourlist">
      {events.map(ev => {
        const { eventId, eventDateTime, soldOut, venueName, url, city } = ev;
        return (
          <li key={eventId}>
            <div className="flex">
              <div className="date">{moment(eventDateTime).format('DD.MM.YY')}</div>
              <div className="title">
                {venueName}, {city}
              </div>
              <div className="buy">
                <a
                  href={url}
                  className={`button ${soldOut ? 'soldout' : 'vacant'}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {soldOut ? 'UDSOLGT' : 'BILLETTER'}
                </a>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default TourList;
